var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTable",
    {
      staticClass: "objectives-listing-table__table",
      attrs: { hasExpandableRows: _vm.hasExpandableRows }
    },
    [
      _c(
        "CompassTableHead",
        { attrs: { isFixed: "" }, on: { sort: _vm.handleSortListingTable } },
        [
          _vm._l(_vm.visibleColumns, function(column) {
            return _c(
              "CompassTableHeadCell",
              {
                key: "objectives-listing-table__table-column-" + column.code,
                attrs: { fixed: column.fixed, sortable: column.sortable }
              },
              [_vm._v("\n            " + _vm._s(column.label) + "\n        ")]
            )
          }),
          _vm._v(" "),
          _c("CompassTableHeadCell", { attrs: { fixed: "right" } })
        ],
        2
      ),
      _vm._v(" "),
      _c("CompassTableBody", {
        scopedSlots: _vm._u(
          [
            _vm.isEmptyList
              ? {
                  key: "empty",
                  fn: function() {
                    return [
                      _c("ObjectivesListingTableEmpty", {
                        attrs: {
                          hasActiveFilters: _vm.hasActiveFilters,
                          buttonConfig: _vm.createObjectiveButton
                        },
                        on: { "reset-filters": _vm.handleResetFilters }
                      })
                    ]
                  },
                  proxy: true
                }
              : {
                  key: "default",
                  fn: function() {
                    return [
                      _vm._l(_vm.rows, function(row) {
                        return [
                          _c("ObjectivesListingTableRow", {
                            key:
                              "objectives-listing-table__table-row-" + row.id,
                            attrs: { row: row, columns: _vm.visibleColumns },
                            on: {
                              "update:subrowVisibility": function(
                                subrowVisibility
                              ) {
                                row.subrowsVisible = subrowVisibility
                              }
                            }
                          }),
                          _vm._v(" "),
                          row.subrows.length > 0
                            ? _c("ObjectivesListingTableSubrow", {
                                key:
                                  "objectives-listing-table__table-row-" +
                                  row.id +
                                  "-subrow",
                                attrs: {
                                  rowId: row.id,
                                  subrows: row.subrows,
                                  subrowColumns: row.subrowColumns,
                                  visible: row.subrowsVisible
                                }
                              })
                            : _vm._e()
                        ]
                      })
                    ]
                  },
                  proxy: true
                }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }